/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_h2h_ahead_count = /** @type {(inputs: { driver: NonNullable<unknown>, count: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.driver} ahead: ${i?.count}`)
};

const es_f1_h2h_ahead_count = /** @type {(inputs: { driver: NonNullable<unknown>, count: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.driver} adelante: ${i?.count}`)
};

const de_f1_h2h_ahead_count = /** @type {(inputs: { driver: NonNullable<unknown>, count: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.driver} vorne: ${i?.count}`)
};

const nl_f1_h2h_ahead_count = /** @type {(inputs: { driver: NonNullable<unknown>, count: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.driver} voor: ${i?.count}`)
};

const fr_f1_h2h_ahead_count = /** @type {(inputs: { driver: NonNullable<unknown>, count: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.driver} devant : ${i?.count}`)
};

const it_f1_h2h_ahead_count = /** @type {(inputs: { driver: NonNullable<unknown>, count: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.driver} davanti: ${i?.count}`)
};

const pt_br2_f1_h2h_ahead_count = /** @type {(inputs: { driver: NonNullable<unknown>, count: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.driver} na frente: ${i?.count}`)
};

const pt_f1_h2h_ahead_count = /** @type {(inputs: { driver: NonNullable<unknown>, count: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.driver} à frente: ${i?.count}`)
};

const ja_f1_h2h_ahead_count = /** @type {(inputs: { driver: NonNullable<unknown>, count: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.driver} 先行: ${i?.count}`)
};

const zh_f1_h2h_ahead_count = /** @type {(inputs: { driver: NonNullable<unknown>, count: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.driver}领先：${i?.count}`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ driver: NonNullable<unknown>, count: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_h2h_ahead_count = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_h2h_ahead_count(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_h2h_ahead_count", locale)
	if (locale === "en") return en_f1_h2h_ahead_count(inputs)
	if (locale === "es") return es_f1_h2h_ahead_count(inputs)
	if (locale === "de") return de_f1_h2h_ahead_count(inputs)
	if (locale === "nl") return nl_f1_h2h_ahead_count(inputs)
	if (locale === "fr") return fr_f1_h2h_ahead_count(inputs)
	if (locale === "it") return it_f1_h2h_ahead_count(inputs)
	if (locale === "pt-BR") return pt_br2_f1_h2h_ahead_count(inputs)
	if (locale === "pt") return pt_f1_h2h_ahead_count(inputs)
	if (locale === "ja") return ja_f1_h2h_ahead_count(inputs)
	return zh_f1_h2h_ahead_count(inputs)
};